import { useMutation, useQueryClient } from '@tanstack/react-query';
import { dismissUsernameLoginBanner } from '../service';
import { AuthQueryFactory } from '../utils/query-factory';

export function useDismissUsernameLoginBanner() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: dismissUsernameLoginBanner,
        onSuccess: (session) => {
            queryClient.setQueryData(AuthQueryFactory.session(), session);
        },
    });
}
